const forEach = require('lodash/forEach');
const get = require('lodash/get');
const localizeElement = require('../tags/localize-element');
const getAttributes = require('../tags/get-attributes');

/**
 * Loops through data to render the templateElement multiple times.
 *
 * Syntax:
 *
 * <span flow-order="1231232" flow-each="items">
 *   <span flow-selector="name" flow-default="N/A"></span>
 * </span>
 *
 * With order:
 * {
 *  id: 1231232,
 *  items: [
 *    { name: 'Hat' },
 *    { name: 'Pants' },
 *    { },
 *  ]
 * }
 *
 * Will result in the following HTML:
 *
 * <span flow-order="1231232">
 *   <span flow-selector="name" flow-default="N/A">Hat</span>
 *   <span flow-selector="name" flow-default="N/A">Pants</span>
 *   <span flow-selector="name" flow-default="N/A">N/A</span>
 * </span>
 *
 * @param  {Object} templateElement The dom node represeting the template for the loop
 * @param  {Object} attributes      The attributes for templateElement
 * @param  {Object} data            The data to use for looking up localized
 *                                  value referenced by the `flow-selector`
 *                                  attributes in child nodes
 */
function localizeEach(templateElement, attributes, data) {
  const dataItems = get(data, attributes.each);
  if (dataItems && dataItems.length) {
    forEach(dataItems, (dataItem) => {
      const clonedElement = templateElement.cloneNode(true);
      const clonedChildren = clonedElement.querySelectorAll('[flow-selector]');

      forEach(clonedChildren, (clonedChild) => {
        const clonedChildAttributes = getAttributes(clonedChild);
        localizeElement(clonedChild, clonedChildAttributes, dataItem);
      });

      clonedElement.removeAttribute('flow-each');
      templateElement.parentNode.insertBefore(clonedElement, templateElement);
    });
  }

  templateElement.remove();
}

module.exports = localizeEach;



// WEBPACK FOOTER //
// ./static/js/v0/utilities/tags/localize-each.js